import axios from './context/axios';

export const doctorService = {
  // Get all doctors
  getAllDoctors: async () => {
    try {
      const response = await axios.get('/doctors/');
      return response.data;
    } catch (error) {
      console.error('Error fetching doctors:', error);
      throw error;
    }
  },

  // Get doctor by ID
  getDoctorById: async (doctorId) => {
    try {
      const response = await axios.get(`/doctors/${doctorId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching doctor with ID ${doctorId}:`, error);
      throw error;
    }
  },

  // Update doctor (admin only)
  updateDoctor: async (doctorId, doctorData) => {
    try {
      const response = await axios.put(`/doctors/${doctorId}`, doctorData);
      return response.data;
    } catch (error) {
      console.error(`Error updating doctor with ID ${doctorId}:`, error);
      throw error;
    }
  },

  // Delete doctor (admin only)
  deleteDoctor: async (doctorId) => {
    try {
      const response = await axios.delete(`/api/doctors/${doctorId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting doctor with ID ${doctorId}:`, error);
      throw error;
    }
  }
};